// extracted by mini-css-extract-plugin
export default {"portalLine":"SectionReveal_portalLine__XpPAD","portalGlow":"SectionReveal_portalGlow__rxfGZ"};